import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input, Table, Typography, Space, Tooltip, Button, Badge, Row, Col, Tag, Spin, Popconfirm, Modal, DatePicker, Image, Select, Radio } from 'antd';
import { EyeOutlined, SearchOutlined, SolutionOutlined, UserOutlined } from '@ant-design/icons';
// import NoticeBoard from '../../components/notice-board/NoticeBoard';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import moment from 'moment';
import Utils from '../../../misc/Utils';
import Enums from '../../../misc/Enums';
import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import DocumentViewer from '../../../components/document-viewer/DocumentViewer';
import ProcessingModal from '../../../components/processing/ProcessingModal';

const { Text, Link } = Typography;
const { Option } = Select;

export function ApplicationListCDLI() {
   const navigate = useNavigate();

   const [searchText, setSearchText] = useState("");
   const [searchedColumn, setSearchedColumn] = useState("");

   const subdomain = localStorage.getItem("lms-subdomain");
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   const customFormat = value => `${value.format('MMM. D, YYYY h:mm a')}`;
   // const subdomain = localStorage.getItem("lms-subdomain");

   const [legendCount, setLegendCount] = useState({
      pending: 0,
      accepted: 0,
      not_accepted: 0,
      rejected: 0,
      for_assessment: 0,
      enrolled: 0
   });

   const [applicantList, setApplicantList] = useState([]);
   const [applicantListFiltered, setApplicantListFiltered] = useState([]);
   const [listLoading, setListLoading] = useState(false);
   const [updating, setUpdating] = useState(false);
   const [applicantID, setApplicantID] = useState(null);
   const [validPoP, setValidPoP] = useState(false);
   const [docToView, setDocToView] = useState(null);
   const [bankDetails, setBankDetails] = useState(null);

   const [modalPoPValidate, setModalPoPValidate] = useState(false);
   const [modalAssessmentPoPValidate, setModalAssessmentPoPValidate] = useState(false);
   const [previewDoc, setPreviewDoc] = useState(false);
   const [modalViewOnsitePayment, setModalViewOnsitePayment] = useState(false);

   const [selectedScheme, setSelectedScheme] = useState(null);
   const [paymentSchemes, setPaymentSchemes] = useState([]);
   const [currentDocument, setCurrentDocument] = useState(null);
   const [selectedSOF, setSelectedSOF] = useState(null);
   const [sof, setSOF] = useState([]);

   useEffect(() => {
      Utils.verifyJwt();

      window.addEventListener('error', e => {
         if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
            const resizeObserverErrDiv = document.getElementById(
               'webpack-dev-server-client-overlay-div'
            );
            const resizeObserverErr = document.getElementById(
               'webpack-dev-server-client-overlay'
            );
            if (resizeObserverErr) {
               resizeObserverErr.setAttribute('style', 'display: none');
            }
            if (resizeObserverErrDiv) {
               resizeObserverErrDiv.setAttribute('style', 'display: none');
            }
         }
      });

      getApplicants();
   }, []);

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  Reset
               </Button>
               <Button
                  type="link"
                  size="small"
                  onClick={() => {
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Filter
               </Button>
            </Space>
         </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#033D89' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const columns = [
      {
         title: 'Type',
         key: 'student_type',
         ...getColumnSearchProps('student_type'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            object.student_type !== null && object.student_type !== '' &&
            // <Text>{object.student_type.toUpperCase()}</Text>
            <Tag color={object.student_type === 'new' ? 'gold' : 'green'}>{object.student_type.toUpperCase()}</Tag>
         ),
         width: '5%'
      },
      {
         title: 'Applicant Name',
         key: 'applicant_name',
         fixed: 'left',
         sorter: (a, b) => { return a.last_name.localeCompare(b.last_name) },
         ...getColumnSearchProps('last_name'),
         ellipsis: {
            showTitle: false,
         },
         render: object => (
            <Tooltip placement="topLeft" title={object.last_name}>
               <Text><span style={{ textTransform: 'capitalize' }}>{object.last_name + ', ' + object.first_name + ' ' + object.middle_name}</span></Text>
            </Tooltip>
         ),
         width: '20%'
      },
      {
         title: 'Gender',
         key: 'gender',
         sorter: (a, b) => { return a.gender.localeCompare(b.gender) },
         ...getColumnSearchProps('gender'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <Text>
               {
                  object.gender !== null
                     ?
                     <span style={{ textTransform: 'capitalize' }}>{object.gender}</span>
                     :
                     <></>
               }
            </Text>
         ),
         width: '7%'
      },
      {
         title: 'Applying For',
         key: 'applying_for',
         ...getColumnSearchProps('applying_for'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            object.applying_for !== null && object.applying_for !== '' &&
            <Text>{object.applying_for + ' - ' + object.program}</Text>
         ),
         width: '15%'
      },
      {
         title: 'Date Applied',
         key: 'date_applied',
         sorter: (a, b) => { return a.date_applied.localeCompare(b.date_applied) },
         render: object => (
            <Text>
               {moment(object.date_applied).format('MMM. DD, YYYY hh:mm A')}
            </Text>
         ),
         width: '11%'
      },
      {
         title: 'Application Status',
         key: 'application_status',
         ...getColumnSearchProps('application_status'),
         ellipsis: {
            showTitle: true,
         },
         render: object => (
            <div style={{ width: "100%", justifyContent: "left", display: "flex", flexWrap: "wrap" }}>
               {
                  ((object.exam_status === null || object.exam_status === '') &&
                     object.application_status !== 'enrolled' &&
                     object.application_status !== 'approved' &&
                     object.application_status !== 'for_assesment' &&
                     object.is_pop_valid === '1') &&
                  RenderTag('paid')
               }
               {
                  (object.tuition_assessment_pop_valid !== null && object.application_status !== "enrolled") &&
                  RenderTag(object.tuition_assessment_pop_valid === '1' || object.tuition_assessment_pop_valid === 1 ? 'paid' : 'not_paid')
               }
               {
                  RenderTag(object.application_status)
               }
            </div>

         ),
         width: '24%'
      },
      {
         title: 'Action',
         key: 'action',
         render: payload => {
            return (
               <>
                  {
                     RenderActionButtons(payload)
                  }
               </>
            );
         },
         width: '18%'
      },
   ].filter(item => !item.hidden);

   // const getApplicants = () => {
   //    setListLoading(true);
   //    axios.get(`${process.env.REACT_APP_API_CPH}/getonlineapplicants`).then((response) => {
   //       console.log(response);

   //       if (response.data) {
   //          const data = response.data;

   //          //--Update legend counts
   //          var loclegend = {
   //             pending: 0,
   //             accepted: 0,
   //             rejected: 0,
   //             for_assessment: 0,
   //             enrolled: 0
   //          }

   //          for (var i = 0; i < data.length; i++) {
   //             switch (data[i].application_status) {
   //                case 'pending':
   //                   loclegend.pending++;
   //                   break;
   //                case 'accepted':
   //                   loclegend.accepted++;
   //                   break;
   //                case 'rejected':
   //                   loclegend.rejected++;
   //                   break;
   //                case 'for_assessment':
   //                   loclegend.for_assessment++;
   //                   break;
   //                case 'enrolled':
   //                   loclegend.enrolled++;
   //                   break;
   //                default:
   //             }
   //          }

   //          setLegendCount({ ...loclegend });
   //          setApplicantList(data);
   //          setApplicantListFiltered(data);
   //          setListLoading(false);
   //       }
   //    }, (error) => {
   //       setListLoading(false);
   //       console.log(error.message);
   //    });
   // }

   const getApplicants = async () => {
      try {
         setListLoading(true);
         const response = await axios.get(`${process.env.REACT_APP_API_CPH}/getonlineapplicants`);

         if (response.data) {
            const data = response.data;

            // Initialize legend counts with default values
            const loclegend = Object.fromEntries([
               'pending', 'accepted', 'rejected', 'for_assessment', 'enrolled'
            ].map(status => [status, 0]));

            // Update counts dynamically
            data.forEach(({ application_status }) => {
               if (loclegend.hasOwnProperty(application_status)) {
                  loclegend[application_status]++;
               }
            });

            setLegendCount(loclegend);
            setApplicantList(data);
            setApplicantListFiltered(data);
         }
      } catch (error) {
         console.error(error.message);
      } finally {
         setListLoading(false);
      }
   };

   const RenderActionButtons = (payload) => {
      return (
         <div style={{ width: "100%", justifyContent: "left", display: "flex", flexWrap: "wrap", gap: "5px" }}>
            {
               payload.application_status !== "for_assessment"
                  ?
                  <div>
                     <Button type='primary' size='small' shape='round' onClick={() => handleReviewApplication(payload.id, payload.application_status)}>{payload.application_status === 'pending' && user_role === "Registrar" ? 'Review' : 'View'}</Button>
                  </div>
                  :
                  user_role !== "Registrar" &&
                  <div>
                     <Button type='primary' size='small' shape='round' onClick={() => handleReviewApplication(payload.id, payload.application_status)}>{payload.application_status === 'pending' && user_role === "Registrar" ? 'Review' : 'View'}</Button>
                  </div>
            }
            {
               (user_role === 'Cashier' && payload.application_status === "accepted") &&
               <div>
                  <Button type='primary' size='small' shape='round' onClick={() => handleViewDoc(payload.id, payload.bank_details)}><EyeOutlined /> Proof of Payment</Button>
               </div>
            }
            {
               (payload.application_status === 'rejected' && user_role === 'Registrar') &&
               <div>
                  <Popconfirm
                     title="Do you want to Unreject this applicant?"
                     onConfirm={() => handleUnreject(payload.id)}
                     okText="Yes"
                     cancelText="No"
                  >
                     <Button type='primary' size='small' shape='round'>Unreject</Button>
                  </Popconfirm>
               </div>
            }
            {
               (payload.application_status === "for_assessment" && payload.tuition_assessment_pop_valid === "1" && user_role === "Registrar") &&
               <>
                  <div>
                     <Popconfirm
                        title="Are you sure you want to mark this applicant as enrolled?"
                        onConfirm={() => handleMarkAsEnrolled(payload.id, payload.student_type)}
                        okText="Yes"
                        cancelText="No"
                        placement='left'
                     >
                        <Button type='primary' size='small' shape='round'>Mark as Enrolled</Button>
                     </Popconfirm>

                  </div>
               </>
            }
            {
               (user_role === 'Cashier' && payload.application_status === "for_assessment") &&
               <>
                  {
                     (payload.tuition_assessment_scheme !== null && payload.tuition_assessment_scheme !== "") &&
                     <div>
                        {/* <Button type='primary' size='small' shape='round' disabled={(payload.tuition_assessment_scheme === null || payload.tuition_assessment_scheme === "")} onClick={() => handleViewAssessment(payload.tuition_assessment_scheme, payload.tuition_assessment_terms)}><EyeOutlined /> Selected Payment Scheme</Button> */}
                        <Button type='primary' size='small' shape='round' onClick={() => handleViewAssessment(payload.tuition_assessment_scheme, payload.tuition_assessment_terms)}><EyeOutlined /> Selected Payment Scheme</Button>
                     </div>

                  }
                  {
                     (payload.tuition_assessment_pop === null || payload.tuition_assessment_pop === "") &&
                     <div>
                        <Button type='primary' size='small' shape='round' onClick={() => handleViewOnsitePayment(payload.id, payload.program)}><SolutionOutlined /> On-Site Payment</Button>
                     </div>
                  }
                  {
                     (payload.tuition_assessment_pop !== null && payload.tuition_assessment_pop !== "") &&
                     <div>
                        <Button type='primary' size='small' shape='round' onClick={() => handleViewAssessmentPoP(payload.id, payload.tuition_assessment_pop)}><EyeOutlined /> Proof of Payment</Button>
                     </div>
                  }

               </>

            }
         </div>
      );
   }

   const RenderTag = (status, mode = "") => {
      var color = '';

      switch (status) {
         case 'pending':
            color = 'gold';
            break;
         case 'accepted':
            color = 'green'
            break;
         case 'rejected':
         case 'not_paid':
            color = 'red';
            break;
         case 'paid':
         case 'enrolled':
            color = 'cyan';
            break;
         case 'for_assessment':
            color = 'blue';
            break;
         default:
      }

      return <>
         <div>
            <Tag color={color}>
               {
                  mode !== ''
                     ?
                     '(' + mode + ') - ' + status.replace(/_/g, ' ').toUpperCase()
                     :
                     status.replace(/_/g, ' ').toUpperCase()
               }
            </Tag>
         </div>
      </>
   }

   const RenderStatusBadge = (status_count, label, color) => {
      return <>
         <div>
            <Badge count={status_count} style={{ backgroundColor: color }} overflowCount={999}>
               <Tag
                  color={color}
                  style={{ cursor: status_count > 0 ? 'pointer' : 'default', padding: '7px' }}
                  onClick={() => handleFilterListByStatus(label, status_count)}
               >
                  {/* {label.toUpperCase()} */}
                  {label.replace(/_/g, ' ').toUpperCase()}
               </Tag>
            </Badge>
         </div>
      </>
   }

   const RenderStatusCounts = () => {
      return <>
         <div style={{ width: "100%", justifyContent: "center", display: "flex", flexWrap: "wrap", gap: "10px", paddingBottom: "10px" }}>
            {RenderStatusBadge(legendCount.pending, "pending", "gold")}
            {RenderStatusBadge(legendCount.accepted, "accepted", "green")}
            {RenderStatusBadge(legendCount.rejected, "rejected", "red")}
            {RenderStatusBadge(legendCount.for_assessment, "for_assessment", "blue")}
            {/* {RenderStatusBadge(legendCount.enrolled, "enrolled", "cyan")} */}
            <Button className='button-shadow' type='primary' shape='round' onClick={() => getApplicants()}>Refresh</Button>
         </div>
      </>
   }

   const handleFilterListByStatus = (status, count) => {
      if (count > 0) {
         var filteredList = applicantList.filter(student => student.application_status === status);

         setApplicantListFiltered(filteredList);
      }
   }

   const handleReviewApplication = (id, status) => {
      navigate(`/reviewapplication?id=${id}`, { state: { status } });
   }

   const handleViewDoc = (id, bank_details) => {
      //-- Get proof of payment url from documents
      var items = applicantListFiltered.filter(item => item.id === id);
      let docs = JSON.parse(items[0].documents);

      setBankDetails(bank_details);
      setDocToView(docs.proof_of_payment);
      setApplicantID(id);
      setModalPoPValidate(true);
   }

   const handleMarkAsPaid = (val, t) => {
      setUpdating(true);

      var url = `${process.env.REACT_APP_API_CPH}/markaspaid?id=${applicantID}&t=${t}&v=${val}`;

      axios.post(url).then((response) => {
         if (response.data) {
            setModalPoPValidate(false);
            setUpdating(false);
            getApplicants();

            Modal.success({
               title: 'Online Application',
               content: 'Setting mark as paid successful.',
               centered: true,
               // onOk: getApplicants(),
            });
         }
      }, (error) => {
         setModalPoPValidate(false);
         setUpdating(false);
         Modal.error({
            title: 'Online Application',
            content: error.response.data,
            centered: true
         });
      });
   }

   const handlePoPValidate = (id, status) => {
      changeStatus(id, status).then(() => {
         setModalPoPValidate(false);
      });
   }

   const handleUnreject = (id) => {
      changeStatus(id, "pending");
   }

   const changeStatus = async (id, status) => {
      setUpdating(true);
      var url = `${process.env.REACT_APP_API_CPH}/changeapplicationstatus?id=${id}&ns=${status}`;

      axios.post(url).then((response) => {
         if (response.data) {
            setUpdating(false);
            getApplicants();

            Modal.success({
               title: 'Online Application',
               content: 'Status change successful.',
               centered: true,
               // onOk: getApplicants(),
            });
         }
      }, (error) => {
         setUpdating(false);
         Modal.error({
            title: 'Online Application',
            content: error.response.data,
            centered: true
         });
      });
   };

   const handleViewAssessment = (selected_scheme, schemes) => {
      setSelectedScheme(selected_scheme);
      setDocToView(schemes);
      setPreviewDoc(true);
   };

   const handleViewAssessmentPoP = (id, pop) => {
      setApplicantID(id);
      setDocToView(pop);
      setModalAssessmentPoPValidate(true);
   }

   const handleMarkAsEnrolled = (id, type) => {
      setUpdating(true);
      var url = `${process.env.REACT_APP_API_CPH}/tagasenrolled?id=${id}&st=${type === null || type === "" ? "new" : type}`;

      axios.post(url).then((response) => {
         if (response.data) {
            setUpdating(false);
            Modal.success({
               title: 'Online Application',
               content: 'Applicant is now enrolled.',
               centered: true,
               onOk: getApplicants(),
            });
         }
      }, (error) => {
         setUpdating(false);
         Modal.error({
            title: 'Online Application',
            content: error.response.data,
            centered: true
         });
      });
   }

   const GetSOF = (id, program) => {
      axios.get(`${process.env.REACT_APP_API_CPH}/getsof?id=${id}&p=${program}`).then((response) => {
         if (response.data) {
            const data = response.data;

            if (data !== null && data !== "") {
               if (data.length > 1) {
                  setSOF(data);
                  setSelectedSOF(null);
                  setCurrentDocument(null);
               }
               else {
                  setSOF([])
                  setSelectedSOF(data[0].description);
                  setCurrentDocument(data[0].document);
               }
            }

            GetPaymentSchemes();
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const GetPaymentSchemes = () => {
      axios.get(`${process.env.REACT_APP_API_CPH}/v2/paymentschemes`).then((response) => {
         if (response.data) {
            const data = response.data;

            if (data !== null && data !== "") {
               var ps = data;

               setPaymentSchemes(ps);
               setModalViewOnsitePayment(true);
            }
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const handleViewOnsitePayment = (applicant_id, program) => {
      setApplicantID(applicant_id);
      GetSOF(applicant_id, program);
   }

   const handleSetPaymentScheme = () => {
      setUpdating(true);
      var url = `${process.env.REACT_APP_API_CPH}/updateselectedfee?id=${applicantID}&fv1=${selectedScheme}&fv2=${currentDocument}&fv3=${selectedSOF}`;

      axios.post(url).then((response) => {
         if (response.data) {
            setModalViewOnsitePayment(false);
            handleMarkAsPaid(true, "assessment_pop");

            setSOF([])
            setSelectedSOF(null);
            setCurrentDocument(null);
            setSelectedScheme(null);
         }
      }, (error) => {
         setUpdating(false);

         Modal.error({
            title: 'Online Application',
            content: error.response.data,
            centered: true
         });
      });
   }

   const handleSOFChange = (val) => {
      let _sof = [...sof];
      let result;
      _sof.forEach(item => {
         if (item.description === val) {
            result = item;
         }
      });

      setCurrentDocument(result.document);
      setSelectedSOF(result.description);
   }

   const downloadPOP = (url) => {
      Utils.downloadFile(url, `POP_${moment().format("MM-DD-YYYY")}`).then(() => {
         console.log("Download successful.");
      }).catch((error) => {
         console.log(error.message);

         Modal.error({
            title: 'Online Application',
            content: error.response.data,
            centered: true
         });
      });
   }

   return (
      <>
         <ProcessingModal
            processing={updating}
            title={'Brainee LMS'}
         />
         <div className="dashboard-area-all application-page">
            <div className="dashboard-item">
               <div className="dashboard-item-inner">
                  <ul>
                     <li className="active">Student Applicant Tracker</li>
                  </ul>
               </div>

               <div className="dashboard-item-inner3">
                  {
                     RenderStatusCounts()
                  }
                  <Table
                     loading={listLoading}
                     size='small'
                     rowKey={'uid'}
                     columns={columns}
                     dataSource={applicantListFiltered}
                     pagination={false}
                     scroll={{
                        x: '1000px',
                        y: 'calc(100vh - 10.5rem)',
                     }}
                     // style={{ minWidth: "1000px" }}
                     footer={() => 'Total Records: ' + applicantListFiltered.length}
                  />
               </div>
            </div>
         </div>

         <Modal
            key='pop-assessment-validate'
            title={"Validate Proof of Payment"}
            okText={"Paid"}
            cancelText={'Not Paid'}
            okButtonProps={{ type: 'primary', shape: "round" }}
            cancelButtonProps={{ type: 'primary', shape: 'round' }}
            centered
            destroyOnClose={true}
            open={modalAssessmentPoPValidate}
            width='75%'
            onCancel={() => setModalAssessmentPoPValidate(false)}
            footer={[
               <Row>
                  <Col span={12} style={{ textAlign: "left" }}>
                     <Button key="paid" type='primary' shape='round' onClick={() => downloadPOP(`${docToView}`)}>Download</Button>
                  </Col>
                  <Col span={12} style={{ textAlign: "right" }}>
                     <Button key="paid" type='primary' shape='round' onClick={() => handleMarkAsPaid(true, "assessment_pop")}>Paid</Button>
                     <Button key="notpaid" type='primary' shape='round' onClick={() => handleMarkAsPaid(false, "assessment_pop")}>Not Paid</Button>
                     <Button key="close" className="modal-dismiss-btn" shape='round' onClick={() => setModalAssessmentPoPValidate(false)}>Close</Button>
                  </Col>
               </Row>
            ]}
         >
            <div className='essay_list_container' style={{ background: "#fff" }}>
               <div
                  className={'modal-document-viewer'}
                  style={{ height: "calc(100vh - 220px)" }}
               >
                  <Image
                     // src={`${process.env.REACT_APP_API_S3_URL}/${subdomain}/${docToView}`}
                     src={`${process.env.REACT_APP_API_S3_URL}/${subdomain}/${docToView}`}
                     style={{ minHeight: "calc(100vh - 220px)", maxHeight: "calc(100vh - 220px)" }}
                  />

               </div>
               <div><Text>Bank Details: <b>{bankDetails}</b></Text></div>
            </div>
         </Modal>

         <Modal
            key='pop-validate'
            title={"Validate Proof of Payment"}
            okText={"Paid"}
            cancelText={'Not Paid'}
            okButtonProps={{ type: 'primary', shape: "round" }}
            cancelButtonProps={{ type: 'primary', shape: 'round' }}
            centered
            destroyOnClose={true}
            open={modalPoPValidate}
            width='75%'
            onCancel={() => setModalPoPValidate(false)}
            footer={[
               <Row>
                  <Col span={12} style={{ textAlign: "left" }}>
                     <Button key="paid" type='primary' shape='round' onClick={() => downloadPOP(`${docToView}`)}>Download</Button>
                  </Col>
                  <Col span={12} style={{ textAlign: "right" }}>
                     <Button key="paid" type='primary' shape='round' onClick={() => handlePoPValidate(applicantID, 'for_assessment')}>Paid</Button>
                     <Button key="notpaid" type='primary' shape='round' onClick={() => handleMarkAsPaid(false, "is_pop_valid")}>Not Paid</Button>
                     <Button key="close" className="modal-dismiss-btn" shape='round' onClick={() => setModalPoPValidate(false)}>Close</Button>
                  </Col>
               </Row>
            ]}
         >
            <div className='student_list_container'>
               <DocumentViewer
                  document={docToView}
                  pdfshowdownload={true}
                  pdfshowprint={true}
                  ismodal={true}
                  dvheight={"calc(100vh - 220px)"}
               />
            </div>
         </Modal>

         <Modal
            key='preview-assessment-scheme'
            title={"Preview Assessment"}
            okText={"Close"}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ shape: "round" }}
            centered
            destroyOnClose={true}
            open={previewDoc}
            width='75%'
            onCancel={() => { setPreviewDoc(false); }}
            onOk={() => { setPreviewDoc(false); }}
            footer={[
               <Row style={{ width: "100%" }}>
                  <Col style={{ width: "70%", textAlign: "left" }}>{'Selected Payment Scheme: '}<b>{selectedScheme}</b></Col>
                  <Col style={{ width: "30%", textAlign: "right" }}>
                     <Button className='button-shadow' size='middle' type='primary' shape='round' onClick={() => setPreviewDoc(false)}>
                        Close
                     </Button>
                  </Col>
               </Row>
            ]}
         >
            <div className='essay_list_container' style={{ background: "#fff" }}>
               <div style={{ width: "100%", height: "calc(100vh - 195px)" }}>
                  <Worker workerUrl={process.env.PUBLIC_URL + "/js/pdf.worker.min.js"}>
                     <Viewer
                        pageLayout={{
                           transformSize: ({ size }) => ({
                              height: size.height + 30,
                              width: size.width + 30,
                           }),
                        }}
                        fileUrl={`${process.env.REACT_APP_API_S3_URL}/${subdomain}/${docToView}`}
                        defaultScale={SpecialZoomLevel.PageWidth}
                        initialPage={0}
                     />
                  </Worker>
               </div>
            </div>
         </Modal>

         <Modal
            key="modal-onsite-payment"
            title='On-Site Payment'
            destroyOnClose={true}
            centered
            okText={"Paid"}
            cancelText={"Close"}
            open={modalViewOnsitePayment}
            okButtonProps={{ shape: "round" }}
            cancelButtonProps={{ shape: "round" }}
            onOk={() => handleSetPaymentScheme()}
            onCancel={() => setModalViewOnsitePayment(false)}
         >
            <Space direction="vertical">
               {
                  sof.length > 1 &&
                  <div>
                     <Text>Schedule of Fees</Text>&nbsp;&nbsp;
                     <Select
                        key={'uid'}
                        showArrow
                        // disabled={processed}
                        size='middle'
                        style={{ minWidth: "300px" }}
                        allowClear
                        onChange={(val) => handleSOFChange(val)}
                        onClear={() => setSelectedSOF(null)}
                     // defaultValue={selectedScheme}
                     >
                        {sof.map(({ id, document, description }) => {
                           return <Option value={description}>{description}</Option>
                        })}
                     </Select>&nbsp;&nbsp;
                  </div>
               }
               {
                  paymentSchemes.length > 0 &&
                  <div>
                     <Text>Select Payment Terms</Text>&nbsp;&nbsp;
                     <Select
                        key={'uid'}
                        showArrow
                        // disabled={processed}
                        size='middle'
                        style={{ minWidth: "200px" }}
                        allowClear
                        onChange={(val) => setSelectedScheme(val)}
                        onClear={() => setSelectedScheme(null)}
                     // defaultValue={selectedScheme}
                     >
                        {paymentSchemes.map(({ scheme }) => {
                           return <Option value={scheme}>{scheme}</Option>
                        })}
                     </Select>&nbsp;&nbsp;
                  </div>
               }
            </Space>
         </Modal>
      </>
   );
}
